import type { IService } from "@/data/model/Service";
import { Signal, TypedSignal } from "@/data/util/Signal";

import { BaseController } from "@/app/controller/BaseController";

export class ServicesControllerVue extends BaseController {
    public onServiceClicked?: { (service: IService) };

    static onInit = new Signal();
    static onShown = new Signal();
    static onHidden = new Signal();

    static onServiceClicked = new TypedSignal<IService>();

    constructor() {
        super("services");

        ServicesControllerVue.onServiceClicked.add(this.serviceClicked, this);
        ServicesControllerVue.onInit.dispatch();
    }

    protected onBecomeVisible() {
        ServicesControllerVue.onShown.dispatch();
    }

    protected onBecomeInvisible() {
        ServicesControllerVue.onHidden.dispatch();
    }

    private serviceClicked(service: IService) {
        if (this.onServiceClicked) {
            this.onServiceClicked(service);
        }
    }
}
